"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    FileQuestionSolid: function() {
        return FileQuestionSolid;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const FileQuestionSolid = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 4C3 2.34315 4.34315 1 6 1H14C14.2652 1 14.5196 1.10536 14.7071 1.29289L20.7071 7.29289C20.8946 7.48043 21 7.73478 21 8V20C21 21.6569 19.6569 23 18 23H6C4.34315 23 3 21.6569 3 20V4ZM14 3.5L18.5 8H15C14.4477 8 14 7.55228 14 7V3.5ZM11.9675 13C11.5029 13 11.11 13.3177 10.999 13.7493C10.8613 14.2841 10.3161 14.6061 9.78126 14.4684C9.2464 14.3308 8.92442 13.7856 9.06208 13.2507C9.39505 11.957 10.5683 11 11.9675 11C13.6244 11 14.9675 12.3431 14.9675 14C14.9675 14.9314 14.513 15.5493 14.037 16.0087C13.8441 16.1949 13.6245 16.3769 13.4271 16.5405L13.3414 16.6116C13.111 16.8033 12.8905 16.9913 12.6746 17.2071C12.2841 17.5976 11.6509 17.5976 11.2604 17.2071C10.8699 16.8166 10.8699 16.1834 11.2604 15.7929C11.5446 15.5087 11.8241 15.2723 12.0624 15.074L12.1539 14.998C12.3585 14.8282 12.5137 14.6994 12.6481 14.5697C12.922 14.3053 12.9675 14.1732 12.9675 14C12.9675 13.4477 12.5198 13 11.9675 13ZM10.9668 19C10.9668 18.4477 11.4145 18 11.9668 18H11.9768C12.5291 18 12.9768 18.4477 12.9768 19C12.9768 19.5523 12.5291 20 11.9768 20H11.9668C11.4145 20 10.9668 19.5523 10.9668 19Z",
        fill: "currentColor"
    })
}), "FileQuestionSolid");
const _default = FileQuestionSolid;
